// extracted by mini-css-extract-plugin
export default {"gistContainer":"GistContainer_gistContainer__cUHPV"};